var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAddLocationMarkerIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#177991",
  fillRule: "nonzero",
  d: "M12.003 1a7.3 7.3 0 0 1 4.147 1.284l.074.053a6.004 6.004 0 0 0-2.01 3.071 3.667 3.667 0 1 0 .83 4.974 6.008 6.008 0 0 0 3.107 2.328c-1.301 2.528-3.489 5.206-5.582 9.446l-.232.477c-.234.49-.433.49-.667 0-3.333-6.966-7-9.804-7-14.3A7.333 7.333 0 0 1 12.003 1zM21 3l-.001 3H24v2h-3.001L21 11h-2l-.001-3H16V6h2.999L19 3h2z",
  className: "icon"
}))));
export default SvgAddLocationMarkerIcon;